import { authRequest, deAuth, plainRequest } from './index.js'
import { formatResponse } from '@/utils/errorHandler'
import { ability } from '@/plugins/ability'

/**
 * Authenticates user with email and password
 * @param {Object} formData - Object containing email and password
 * @returns {Object} - Response object with user data or error
 */
export async function auth_user (formData){
  try {
    const result = await plainRequest.post('/login', { user: formData })
    const token = result.headers['authorization']
    
    if (token) {
      localStorage.setItem('uid', token)
      // Assuming result.data.data contains user info including role/admin status
      ability.update(result.data.data) 
      return formatResponse(result.data.data, false)
    } else {
      throw new Error('No authorization token received')
    }
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

/**
 * Registers a new user
 * @param {Object} formData - Object containing registration data
 * @returns {Object} - Response object with user data or error
 */
export async function register_user (formData) {
  try {
    const result = await plainRequest.post('/signup', { user: formData })
    const token = result.headers['authorization']
    
    if (token) {
      localStorage.setItem('uid', token)
      return formatResponse(result.data, false)
    } else {
      throw new Error('No authorization token received')
    }
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

/**
 * Logs out user and removes authentication token
 * FIXED: Previously incorrectly set the token on logout
 * @returns {Object} - Response object confirming logout
 */
export async function delete_token () {
  try {
    const result = await deAuth.delete('/logout')
    localStorage.removeItem('uid')
    localStorage.removeItem('user_data')
    return formatResponse(result, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

/**
 * Redirects user to SSO authentication (legacy method)
 * @deprecated Use redirect_sso_token() for better security
 * @returns {Object} - Response object with user ID or error
 */
export async function redirect_sso (){
  try {
    const result = await authRequest.get('/auth_sso')
    return formatResponse(result.data, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

/**
 * Get secure SSO token for forum authentication.
 * This is the recommended method over redirect_sso().
 * @returns {Object} - Response object with token data or error
 */
export async function redirect_sso_token() {
  try {
    const result = await authRequest.get('/auth_sso/token')
    return formatResponse(result.data, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}